import { JsonObject, JsonProperty } from 'typescript-json-serializer';

export enum LayoutType {
    DESKTOP = 'DESKTOP',
    TABLET = 'TABLET',
    MOBILE = 'MOBILE',
    A4 = 'A4',
}

export enum LayoutElementType {
    WIDGET = 'WIDGET',
    ANALYSIS = 'ANALYSIS',
    RICH_TEXT = 'RICH_TEXT',
}

export type ConstraintsPerLayoutElement = {
    type: LayoutType;
    minWidth: number;
    minHeight: number;
    maxWidth: number;
    maxHeight: number;
};

export type LayoutElement = {
    id: string;
    position: { x: number; y: number };
    type: LayoutElementType;
    size: { width: number; height: number };
    constraints: {
        minWidth: number;
        maxWidth: number;
        minHeight: number;
        maxHeight: number;
    };
};

@JsonObject()
export class LayoutElementClass {
    constructor(
        @JsonProperty({ required: true }) readonly id: string,
        @JsonProperty({ required: true }) readonly position: { x: number; y: number },
        @JsonProperty({ required: true }) readonly type: LayoutElementType,
        @JsonProperty({ required: true }) readonly size: { width: number; height: number },
        @JsonProperty({ required: true })
        readonly constraints: {
            minWidth: number;
            maxWidth: number;
            minHeight: number;
            maxHeight: number;
        }
    ) {}
}

@JsonObject()
export default class Layout {
    constructor(
        @JsonProperty({ required: true }) readonly type: LayoutType,
        @JsonProperty({ required: true }) readonly widgets: LayoutElementClass[]
    ) {}
}
